import Vue from 'vue'
import { round } from 'lodash'

Vue.filter('roundNumber', function (value) {
  return value ? round(value, 1) : 0
})

Vue.filter('formatAmount', function (value) {
  let amount = (value + '.00').replace(/\d(?=(\d{3})+\.)/g, '$&,')
  amount = amount.substr(0, amount.length - 3)
  return amount
})

Vue.filter('formatStatus', function (status) {
  if (status === 'APPROVED') {
    return 'SUCCEED'
  }
  if (status === 'REJECTED') {
    return 'FAILED'
  }
  return status
})



// WEBPACK FOOTER //
// ./src/utils/filter.js